import { ComponentType, ReactNode } from 'react';

import {
  ItemRenderExtensionOptions,
  createItemRenderExtension,
  createItemRenderExtensions,
  useItemRenderExtensions,
} from '@spotify/confidence-core-react';

export type ToolGroupEntry = {
  tool: string;
  displayName?: string | null;
  input?: unknown;
  result?: { content: string; success: boolean };
};

export type PreviewField = {
  key: string;
  label?: string;
};

export interface ToolExtensionOptions
  extends ItemRenderExtensionOptions<string> {
  icon?: ComponentType<{ size?: number | string; style?: object }>;
  display?: 'prominent' | 'grouped';
  formatLabel?: (entry: ToolGroupEntry) => { text: string; detail?: string };
  renderLabel?: (entry: ToolGroupEntry) => ReactNode;
  renderTool?: (entry: ToolGroupEntry) => ReactNode;
  previewFields?: PreviewField[];
}

export const ToolExtensions = createItemRenderExtensions<ToolExtensionOptions>({
  id: 'tool',
});

export const createToolExtension = (options: ToolExtensionOptions) => {
  return createItemRenderExtension<ToolExtensionOptions>(options);
};

export const useToolExtensions = () => {
  return useItemRenderExtensions<ToolExtensionOptions>(ToolExtensions);
};
